import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import { organizationTranslationChunksConfig, organizationTranslationsCs } from '@spartacus/organization/administration/assets';
import { AdministrationRootModule, ORGANIZATION_ADMINISTRATION_FEATURE } from '@spartacus/organization/administration/root';

@NgModule({
  declarations: [],
  imports: [
    AdministrationRootModule
  ],
  providers: [provideConfig({
    featureModules: {
      [ORGANIZATION_ADMINISTRATION_FEATURE]: {
        module: () =>
          import('@spartacus/organization/administration').then((m) => m.AdministrationModule),
      },
    }
  } as CmsConfig),
  provideConfig({
    i18n: {
      resources: organizationTranslationsCs,
      chunks: organizationTranslationChunksConfig,
    },
  })
  ]
})
export class OrganizationAdministrationFeatureModule { }
